import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram } from "lucide-react";
import { LOGO_URL } from "@/data/catalog";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-edge bg-gunmetal">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <img src={LOGO_URL} alt="G5 Auto Restyling" className="h-12 w-12 rounded-full object-cover ring-2 ring-velocity/70" />
          <div>
            <p className="font-display font-black text-xl uppercase tracking-tight">G5 Auto Restyling</p>
            <p className="font-mono text-[10px] tracking-[0.3em] text-steel uppercase">Precision Wrap Atelier</p>
          </div>
        </div>
        <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
          Bespoke color-change wraps, paint protection film, ceramic coating and custom vinyl work — engineered panel
          by panel in a climate-controlled studio.
        </p>
        <div className="flex gap-3 mt-5">
          <a data-testid="footer-instagram-link" href="https://instagram.com/g5autorestyling" target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-raise text-slate-300 hover:text-velocity hover:bg-edge transition-colors" aria-label="Instagram"><Instagram className="h-4 w-4" /></a>
          <a data-testid="footer-tiktok-link" href="https://tiktok.com/@g5autorestyling" target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-raise text-slate-300 hover:text-velocity hover:bg-edge transition-colors" aria-label="TikTok"><svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4"><path d="M16.6 3c.4 2.2 1.9 3.7 4.1 3.9v3c-1.6 0-3-.5-4.1-1.3v6.5a5.9 5.9 0 1 1-5.9-5.9c.3 0 .7 0 1 .1v3.1a2.8 2.8 0 1 0 1.9 2.7V3h3z"/></svg></a>
        </div>
      </div>

      <div>
        <p className="font-mono text-xs tracking-[0.25em] text-velocity uppercase font-bold mb-4">Studio</p>
        <ul className="space-y-3 text-sm text-slate-400">
          <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 mt-0.5 text-steel shrink-0" />20211 E US-412, STE 206<br />Springdale, AR 72764</li>
          <li className="flex items-start gap-2.5"><Phone className="h-4 w-4 mt-0.5 text-steel shrink-0" /><a href="tel:+14793100682" data-testid="footer-phone-link" className="hover:text-white transition-colors">(479) 310-0682</a></li>
          <li className="flex items-start gap-2.5"><Mail className="h-4 w-4 mt-0.5 text-steel shrink-0" /><a href="mailto:g5autorestyling@gmail.com" data-testid="footer-email-link" className="hover:text-white transition-colors">g5autorestyling@gmail.com</a></li>
          <li className="flex items-start gap-2.5"><Clock className="h-4 w-4 mt-0.5 text-steel shrink-0" />Mon–Sat · 9:00 AM – 6:00 PM</li>
        </ul>
      </div>

      <div>
        <p className="font-mono text-xs tracking-[0.25em] text-velocity uppercase font-bold mb-4">Shortcuts</p>
        <ul className="space-y-3 text-sm">
          <li><Link data-testid="footer-customizer-link" to="/customizer" className="text-slate-400 hover:text-velocity transition-colors">Create Your Own Wrap</Link></li>
          <li><Link data-testid="footer-decals-link" to="/decals" className="text-slate-400 hover:text-velocity transition-colors">Custom Decals Studio</Link></li>
          <li><Link data-testid="footer-tint-link" to="/tint" className="text-slate-400 hover:text-velocity transition-colors">Tint Lab</Link></li>
          <li><Link data-testid="footer-quote-link" to="/contact" className="text-slate-400 hover:text-velocity transition-colors">Request a Quote</Link></li>
          <li><Link data-testid="footer-book-link" to="/book" className="text-slate-400 hover:text-velocity transition-colors">Book an Appointment</Link></li>
          <li><Link data-testid="footer-home-link" to="/" className="text-slate-400 hover:text-velocity transition-colors">Services & Gallery</Link></li>
          <li><Link data-testid="footer-admin-link" to="/admin" className="text-slate-500 hover:text-velocity transition-colors">Owner Login</Link></li>
        </ul>
        <p className="mt-6 text-xs text-slate-500 leading-relaxed border border-edge rounded-lg p-3 bg-panel">
          Every install carries a 1-year workmanship warranty alongside the film manufacturer's coverage.
        </p>
      </div>
    </div>
    <div className="border-t border-edge py-5 text-center text-xs text-slate-500 font-mono tracking-wider">
      © {new Date().getFullYear()} G5 AUTO RESTYLING STUDIO — BUILT FOR THE OBSESSED
    </div>
  </footer>
);

export default Footer;
